export const userData = {
  name: "RAMACHANDRAN",
  profileImage: "/Ramachandran.png",
  title: "MCA Fresher | Full-Stack Developer",
  shortIntro: "An enthusiastic MCA fresher with a passion for building user-friendly and efficient web applications. Skilled in React, Node.js, and modern CSS frameworks like Tailwind.",
  aboutMe: "Hi, I'm Ramachandran, a passionate Full-Stack & MERN Developer. I build responsive websites and scalable applications focused on performance and user experience.",
  education: [
    {
      degree: "Master of Computer Application (MCA)",
      institution: "RVS College of Arts and Science, Coimbatore",
      grade: "83.75% (1st year)",
      status: "Pursuing",
      period: "Pursuing"
    },
    {
      degree: "Bachelor of Computer Application (BCA)",
      institution: "Sengunthar Arts and Science College, Tiruchengode",
      grade: "68%",
      status: "Completed (2025)",
      period: "2025"
    }
  ],
  skills: [
    { name: "Frontend", items: ["React", "HTML5", "CSS3", "JavaScript (ES6+)"] },
    { name: "Backend", items: ["Node.js", "Express", "MongoDB"] },
    { name: "Tools", items: ["Git", "GitHub", "VS Code", "Postman", "AWS", "NPM"] },
    { name: "Soft Skills", items: ["Problem Solving", "Teamwork", "Communication", "Fast Learner"] }
  ],
  projects: [
    {
      title: "E-Commerce Website",
      description: "Responsive e-commerce platform built with HTML, CSS and JavaScript. Features product catalog and cart.",
      techStack: ["HTML5", "CSS3", "JavaScript"],
      image: "/E-commerce.jpg",
      link: "https://ramachandran0505.github.io/skmcart/",
      github: "https://github.com/ramachandran0505/skmcart"
    },
    {
      title: "Ticket Management System (TMS)",
      description: "A responsive Ticket Management System built using React, Node.js, and MongoDB. This application allows users to create, track, and manage support tickets efficiently.",
      techStack: ["React", "Node.js", "MongoDB"],
      image: "/tms.jpg",
      link: "https://tms042.rvscasmcafsd2k25.in/login",
      github: "https://github.com/ramachandran0505/tms-project.git"
    },
    {
      title: "MAPPING",
      description: "Map project using HTML and JavaScript typically involves displaying an interactive map on a webpage.",
      techStack: ["HTML5", "JavaScript", "Leaflet/Maps API"],
      image: "/mapping.jpg",
      link: "https://ramachandran0505.github.io/Map-Route/",
      github: "https://github.com/ramachandran0505/Map-Route"
    },
    {
      title: "EYE-BALL",
      description: "Eyeball that moves and follows the mouse cursor using HTML, CSS, and JavaScript.",
      techStack: ["HTML5", "CSS3", "JavaScript"],
      image: "/Eyeball.png",
      link: "https://ramachandran0505.github.io/Eyeball/",
      github: "https://github.com/ramachandran0505/Eyeball"
    },
    {
      title: "MOVING-BALL",
      description: "A simple moving ball effect achieved using core CSS animations and styling.",
      techStack: ["HTML5", "CSS3"],
      image: "/Moving ball.png",
      link: "https://ramachandran0505.github.io/Ball-Moving/",
      github: "https://github.com/ramachandran0505/Ball-Moving"
    },
    {
      title: "CALCULATOR",
      description: "A basic calculator project using HTML and JavaScript involving structured UI and functional logic for mathematical operations.",
      techStack: ["HTML5", "CSS3", "JavaScript"],
      image: "/Calculator.jpg",
      link: "https://ramachandran0505.github.io/Calculator/",
      github: "https://github.com/ramachandran0505/Calculator"
    }
  ],
  resumeLink: "/RAM-RESUME-FINAL.pdf",
  contact: {
    email: "ramachandranboominathan@gmail.com",
    phone: "+91 63811 22084",
    location: "Thiruvarur, TN",
    socialLinks: [
      { name: "LinkedIn", url: "https://www.linkedin.com/in/ramachandran-exe", icon: "Linkedin" },
      { name: "GitHub", url: "https://github.com/ramachandran0505", icon: "Github" },
      { name: "Instagram", url: "https://www.instagram.com/ram__ofl?igsh=NDNtZjg3dGxxemtw", icon: "Instagram" }
    ]
  }
};
